<template>
  <div class="flex items-center justify-start">
    <span v-if="item"><IconCheckCircle class="size-6 text-theme-300" /></span>
    <span v-else>-</span>
  </div>
</template>

<script setup lang="ts">
import IconCheckCircle from '@/assets/icons/IconCheckCircle.vue';
defineProps<{
  header?: string;
  item?: boolean | number;
}>();
</script>
